import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/motoguzzi_logo.png'
import _imports_1 from '@/assets/img/logo_clan_guzzi.svg'


const _hoisted_1 = { class: "onboarding welcome text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "motoGuzziLogo mb-4"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "motoGuzziLogoTheClan mb-3"
}, null, -1)
const _hoisted_6 = { class: "loginRegisterButtonBox" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _hoisted_4,
        _createVNode(_component_form_field, {
          type: "select",
          list: _ctx.availableLanguages,
          modelValue: _ctx.selectedLanguage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
          class: "languageSelect",
          showSearch: false
        }, null, 8, ["list", "modelValue"]),
        _hoisted_5,
        _createVNode(_component_localized_text, {
          localizedKey: "SeiunguzzistaEffettuailloginconiltuoprofilo",
          text: "Sei un guzzista?</br> Effettua il login con il tuo profilo “The Clan Owner” per ritirare il welcome kit e approfittare di tutti i vantaggi oppure tieni a portata i dati della tua Moto Guzzi e registrati gratuitamente.",
          class: "fs_16 white d-block mt-4"
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "primaryButton w-100 mt-4",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/login')))
        }, [
          _createVNode(_component_localized_text, {
            class: "fs_18",
            localizedKey: "app_Login",
            text: "Login"
          })
        ]),
        _createElementVNode("a", {
          class: "sameAsButton secondaryButton w-100 mt-3",
          href: _ctx.registerLink,
          target: "_blank"
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_Registrati",
            text: "Registrati"
          })
        ], 8, _hoisted_7)
      ])
    ])
  ]))
}